// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__zMNph","topBottomGutter":"Layout_topBottomGutter__1c17w"};